var map = {
	"./Pin-Dark-Delegacia.svg": 641,
	"./Pin-Dark-Moto.svg": 642,
	"./Pin-Dark-Ocorrencia.svg": 643,
	"./Pin-Dark-Policial.svg": 644,
	"./Pin-Dark-Viatura.svg": 645,
	"./Pin-Light-Delegacia.svg": 646,
	"./Pin-Light-Moto.svg": 647,
	"./Pin-Light-Ocorrencia.svg": 648,
	"./Pin-Light-Policial.svg": 649,
	"./Pin-Light-Viatura.svg": 650,
	"./X.svg": 1140,
	"./camera.svg": 1141,
	"./clusterDarkBig.svg": 1142,
	"./clusterDarkSmall.svg": 1143,
	"./clusterLightBig.svg": 1144,
	"./clusterLightSmall.svg": 1145,
	"./logo.svg": 1146,
	"./lpr.svg": 1147,
	"./lpr_third_party.svg": 651,
	"./motorcycle-pin-dark.svg": 1148,
	"./motorcycle-pin-light.svg": 1149,
	"./motorcycle-pin-lightAlt.svg": 1150,
	"./panoramic.svg": 1151,
	"./panoramic_third_party.svg": 652,
	"./pin_event.svg": 1152,
	"./pin_point_of_interest.svg": 361,
	"./pinned.svg": 1153,
	"./pinned_third_party.svg": 653,
	"./ptz.svg": 1154,
	"./ptz_third_party.svg": 654,
	"./user-agent-dark.svg": 1155,
	"./user-agent-light.svg": 1156,
	"./user-agent-lightAlt.svg": 1157,
	"./vehicle-pin-dark.svg": 1158,
	"./vehicle-pin-light.svg": 1159,
	"./vehicle-pin-lightAlt.svg": 1160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 360;